import "./App.css";
import Menu from "./components/Menu";
import Header from "./components/Header";
import React, { useState, useEffect } from "react";
import CookieService from "./services/CookieService";


export default function App() {
  let user = CookieService.get("user");
  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header />
        <div className="col-lg-10">
            <h2>Takaoka Bots</h2>
          </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          {user &&   
          <div className="col-lg-12">
            <i className="fa fa-user"></i> Seja bem vindo(a) {user?.name}
          </div> 
          }
        </div>
      </div>
    </div>
  );
}
